import React from 'react';
import PromotionHelper from "../../../../../services/Menu/services/Promotion/PromotionHelper";

interface Props {
    promotions: any[];
    productState: Record<string, any>;
}

const ProductPromotions = ({promotions, productState}: Props) => {
    const productPromotions = PromotionHelper.getForItem(promotions, productState.item_id);

    if (!productPromotions || !productPromotions.length) return <></>;

    return (
        <div className="promotions-container">
            {productPromotions.map((promotion: any) => (
                <span key={promotion.id} className="badge badge-success-light text-start">{promotion.name}</span>
            ))}
        </div>
    )
}

export default ProductPromotions;